import React from 'react';
import {Route, Routes} from "react-router-dom";
import Home from "../page/Home";
import {Row} from "antd";
import Service from "../page/Service";
import About from "../page/About";
import Contact from "../page/Contact";
import Gdpr from "../page/Gdpr";

function Body() {
    return (
        <>
            <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path="/service" element={<Service/>}/>
                <Route path="/about" element={<About/>}/>
                <Route path="/contact" element={<Contact/>}/>
                <Route path="/gdpr" element={<Gdpr/>}/>
                <Route path={'/*'} element={<div>
                    <Row justify={"center"} align={'middle'} style={{height: '50vh'}}>
                         <h1>nothing here :/</h1>
                    </Row>
                </div>}/>
            </Routes>
        </>
    )
}

export default Body;
